:root ._dsp-flex{display:flex;}
:root ._items-stretch{align-items:stretch;}
:root ._fd-column{flex-direction:column;}
:root ._fb-auto{flex-basis:auto;}
:root ._bxs-border-box{box-sizing:border-box;}
:root ._minH-0px{min-height:0px;}
:root ._minW-0px{min-width:0px;}
:root ._shrink-0{flex-shrink:0;}
:root ._pos-sticky{position:sticky;}
:root ._z-50{z-index:50;}
:root ._t-58px{top:58px;}
:root ._pos-relative{position:relative;}
:root ._gap-t-space-med104641{gap:var(--t-space-medium);}